/**
 * 環境変数の集約管理
 *
 * CRA は `process.env.REACT_APP_*` をビルド時にバンドルする。
 * 文字列値を Boolean に正規化する場合は厳密比較 (=== 'true') を使う。
 * （文字列 'false' が truthy となり本番扱いになるバグの回避。
 *  ドクター側 home_doctor_front commit 95dc1bed と同方針）
 *
 * Amplify Console の各ブランチ別設定値は
 * `homekarte/docs/plans/production-release-readiness.md` Phase B を参照。
 *
 * 既存散らばっていた `process.env.REACT_APP_*` 直接参照は本モジュール経由に統一する。
 */

export const ENV = {
  /**
   * API ベース URL。Amplify Console でブランチ別に設定する。
   * 未設定/空文字列は空文字列で fallback（既存 repository の `|| ''` 挙動と同等）。
   */
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || '',

  /**
   * 本番環境フラグ。将来の GMO MPトークン等の決済 SDK の接続先切替に使用予定。
   * 'true' のみ true。未設定 / 'false' / その他は false（安全側 fallback）。
   */
  IS_PRODUCTION: process.env.REACT_APP_IS_PRODUCTION === 'true',

  /**
   * デバッグログ出力フラグ。'true' のときのみ各 repository の console.log が有効化される。
   *
   * 安全装置: 本番環境（IS_PRODUCTION=true）では誤設定 REACT_APP_DEBUG=true があっても
   * 強制的に false にする。これにより API_BASE_URL / paymentMethodCode 等のビジネス情報が
   * Flutter WebView の DebugChannel 経由で漏れる事故を防ぐ（security-reviewer MEDIUM-2 対応）。
   */
  DEBUG:
    process.env.REACT_APP_IS_PRODUCTION !== 'true' &&
    process.env.REACT_APP_DEBUG === 'true',

  /**
   * モック PDF URL。Mock モード時に PdfButton 等で参照される。
   * 未設定 / 空文字列は null（既存 `|| null` 挙動と同等）。
   */
  MOCK_PDF_URL: process.env.REACT_APP_MOCK_PDF_URL || null,
} as const;

// 本番ビルドで API_BASE_URL が未設定の場合は確実に気付けるよう警告を出す
// （security-reviewer MEDIUM-1 対応: Amplify Console 設定漏れの早期検知）
// jsdom（jest）環境では `process.env.NODE_ENV === 'test'` のため警告が出ない
if (
  ENV.IS_PRODUCTION &&
  !ENV.API_BASE_URL &&
  typeof window !== 'undefined' &&
  process.env.NODE_ENV !== 'test'
) {
  // eslint-disable-next-line no-console
  console.warn(
    '[ENV] REACT_APP_API_BASE_URL is not set on production build. ' +
      'Check Amplify Console environment variables.',
  );
}
